// Direct hex values for MUI (which doesn't support CSS variables)
// These should match the CSS variable values from foundations/colors.css

export default {
  primary: {
    main: '#d95e16', // --tra-color-action-accent-400
    dark: '#b84308', // --tra-color-action-accent-500
  },
  secondary: {
    main: '#313c3f', // --tra-color-neutral-500
  },
  error: {
    main: '#e03d24', // --tra-color-red-400
  },
  text: {
    primary: '#25282a', // --tra-color-neutral-600
  },
  focus: {
    main: '#d95e16', // --tra-color-action-accent-400
  },
  neutral: {
    0: '#ffffff', // --tra-color-neutral-100
    50: '#f5f4f1', // --tra-color-warm-100
    100: '#f5f4f1', // --tra-color-warm-100
    200: '#d4d2ca', // --tra-color-warm-300
    300: '#b3b3b1', // --tra-color-neutral-200
    400: '#747778', // --tra-color-neutral-300
    500: '#747778', // --tra-color-neutral-300
    550: '#423933', // --tra-color-warm-500
    600: '#313c3f', // --tra-color-neutral-500
    700: '#313c3f', // --tra-color-neutral-500
    800: '#25282a', // --tra-color-neutral-600
    900: '#1a1a1a', // --tra-color-neutral-700
  },
  warm: {
    50: '#f5f4f1', // --tra-color-warm-100
    100: '#f5f4f1', // --tra-color-warm-100
    200: '#e9e9e6', // --tra-color-warm-200
    300: '#d4d2ca', // --tra-color-warm-300
    400: '#b4aca6', // --tra-color-warm-400
    500: '#b4aca6', // --tra-color-warm-400
    600: '#747778', // --tra-color-neutral-300
    700: '#423933', // --tra-color-warm-500
    800: '#423933', // --tra-color-warm-500
    900: '#423933', // --tra-color-warm-500
  },
};
